import { array, object, string } from 'yup';

import { ICheckKaiAssistantNameDTO } from '@interfaces/kai/dto/kaiDTO';

import { regExpKaiApiToken } from '@constants/regExp';
import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_50_LENGTH, MAX_250_LENGTH } from '@constants/validationMessages';

interface GetSchemaInterface {
	id?: string;
	handleCheckName: (data: ICheckKaiAssistantNameDTO) => void;
	organizationId: string;
}

export const getSchema = ({
	id,
	organizationId,
	handleCheckName,
}: GetSchemaInterface) => object({
	name: string()
		.required(validationErrMessages.nameRequired)
		.default(null)
		.min(1, getMaxLengthErrMsg('Name', 1))
		.max(MAX_50_LENGTH, getMaxLengthErrMsg('Name', MAX_50_LENGTH))
		.nullable()
		.test('name', 'Assistant’s short name must be unique',
			async (value) => {
				if (!value) return false;

				try {
					await handleCheckName({ name: value, organizationId, id });

					return true;
				} catch (err) {
					return false;
				}
			},
		),
	kaiId: string()
		.required(validationErrMessages.apiTokenRequired)
		.default(null)
		.max(MAX_250_LENGTH, getMaxLengthErrMsg('API Token', MAX_250_LENGTH))
		.nullable()
		.test('kaiId', 'Invalid value',
			(value) => {
				if (!value) return false;

				return !regExpKaiApiToken.test(value);
			},
		),
	users: array().nullable(),
});
